import { eachHour, eachMin, eachSec } from './time.ts'

const formatters = {
  short: new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }),

  full: new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }),

  relative: new Intl.RelativeTimeFormat('en', {
    numeric: 'auto',
    style: 'narrow',
  }),
}

export const formatDate = (
  timestamp: number,
  format: 'short' | 'full' = 'short',
): string => {
  if (timestamp === -1) return 'Unlimited'
  if (!timestamp || timestamp < 0) return 'Never'

  const date = new Date(timestamp * 1000)
  return formatters[format].format(date)
}

const getRelativeTimeUnit = (seconds: number) => {
  const absSeconds = Math.abs(seconds)
  if (absSeconds < 60) return { value: seconds, unit: 'second' as const }
  if (absSeconds < 3600) {
    return { value: Math.floor(seconds / 60), unit: 'minute' as const }
  }
  if (absSeconds < 86400) {
    return { value: Math.floor(seconds / 3600), unit: 'hour' as const }
  }
  return { value: Math.floor(seconds / 86400), unit: 'day' as const }
}

export const formatRelativeTime = (timestamp?: number | null): string => {
  if (!timestamp) return ''
  const seconds = Math.floor((timestamp * 1000 - Date.now()) / 1000)
  const { value, unit } = getRelativeTimeUnit(seconds)
  return formatters.relative.format(value, unit)
}

export const formatRelativeTimeReactive = (
  timestamp?: number | null,
): string => {
  if (!timestamp) return ''

  const diffMs = Math.abs(timestamp * 1000 - Date.now())
  const now = diffMs < 60_000
    ? eachSec.value
    : diffMs < 3_600_000
    ? eachMin.value
    : eachHour.value

  const seconds = Math.floor((timestamp * 1000 - now) / 1000)
  const { value, unit } = getRelativeTimeUnit(seconds)
  return formatters.relative.format(value, unit)
}

export const getDateInputValue = (timestamp?: number): string | undefined => {
  if (!timestamp || timestamp <= 0) return undefined
  return new Date(timestamp * 1000).toLocaleDateString('en-CA')
}
